import { IValue } from "./ivalue";
import { ControlType } from "../controltype";
import { IEnumValue, EnumValueConvert } from "../controltype/dropdownlist/ienumvalue";
import { EventEmitter } from "@angular/core";

export class DropDownListValue implements IValue{

    clear$ = new EventEmitter();

    clearValue(): void {
        this.value = undefined;
        this.clear$.emit();
    }
    setOriginalValue(value: any): void {
        this.value = value;
    }
    getOriginalValue() {
        return this.value;
    }
    getControlType(): ControlType {
        return ControlType.DropDown;
    }
    value: string;
    constructor(data: string = ''){
        this.value = data;
    }
    isEmpty(): boolean {
        return !this.value;
    }
}

export class DropDownListValueConvert{
    convertToObject(obj:IValue):Object{
        let dropDownListValue=obj as DropDownListValue;
        let jobj=new Object();
        let convertor=new EnumValueConvert();
        if(!!(dropDownListValue.value)){
            // jobj["value"]=convertor.convertJObject(dropDownListValue.value);
            jobj["value"] = dropDownListValue.value;
        }
        return jobj;
    }

    initFromObject(jobj:Object):DropDownListValue{
        let dropDownListValue=new DropDownListValue();
        if(!!(jobj["value"])){
            let convertor=new EnumValueConvert();
            // dropDownListValue.value=convertor.initFromJobject(jobj["value"]);
            dropDownListValue.value = jobj["value"];
        }
        return dropDownListValue;
    }
}

